import { adminAuditLogConstants } from "_constants";

const getAuditLogs = (section, startDate, endDate) => {
  return {
    type: adminAuditLogConstants.GET_AUDIT_LOGS_REQUEST,
    section,
    startDate,
    endDate,
  };
};

const searchByUsername = (username, limit) => {
  return {
    type: adminAuditLogConstants.SEARCH_BY_USERNAME_REQUEST,
    username,
    limit,
  };
};

export const adminAuditLogActions = {
  getAuditLogs,
  searchByUsername,
};
